import React, { FC, createContext, useState, ChangeEvent } from 'react'

type ContextState = {
  value?: string
  handleChange: (event: ChangeEvent<HTMLInputElement>) => void
}

export const RadioGroupContext = createContext<ContextState>({ value: '', handleChange: () => { } })

type RadioGroupProps = {
  value?: string
  onChange: (data: string) => void
}

export const RadioGroup: FC<RadioGroupProps> = ({ children, value: valueProp, onChange }) => {
  const [value, setValue] = useState<string | undefined>(valueProp)

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    setValue(event.target.value)
    onChange(event.target.value)
  }

  return (
    <RadioGroupContext.Provider value={{ handleChange, value }}>
      {children}
    </RadioGroupContext.Provider>
  )
}

RadioGroup.displayName = 'RadioGroup'
